var _line, _line2, _line3, _line4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _line5, _line6, _g11, _g12, _g13, _g14, _line7, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _line8, _line9, _text13, _text14, _text15, _text16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSideContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1354.5 458.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1335.458,
    y1: 116.286,
    x2: 54.075,
    y2: 118.286,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1336.154,
    y1: 447.702,
    x2: 54.335,
    y2: 449.702,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55.431,
    y1: 116.727,
    x2: 55.431,
    y2: 449.154,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1335.755,
    y1: 116.761,
    x2: 1335.755,
    y2: 449.128,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1209.661,
    y1: 121.156,
    x2: 1209.661,
    y2: 442.82,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1209.661,
    y1: 121.156,
    x2: 1209.661,
    y2: 127.156,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1209.661,
    y1: 139.543,
    x2: 1209.661,
    y2: 430.627,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1209.661,
    y1: 436.82,
    x2: 1209.661,
    y2: 442.82,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1082.321,
    y1: 121.566,
    x2: 1082.321,
    y2: 443.23,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1082.321,
    y1: 121.566,
    x2: 1082.321,
    y2: 127.566,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1082.321,
    y1: 139.953,
    x2: 1082.321,
    y2: 431.037,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1082.321,
    y1: 437.23,
    x2: 1082.321,
    y2: 443.23,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 954.585,
    y1: 121.597,
    x2: 954.585,
    y2: 443.26,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 954.585,
    y1: 121.597,
    x2: 954.585,
    y2: 127.597,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 954.585,
    y1: 139.983,
    x2: 954.585,
    y2: 431.067,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 954.585,
    y1: 437.26,
    x2: 954.585,
    y2: 443.26,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 823.19,
    y1: 122.076,
    x2: 823.19,
    y2: 443.739,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 823.19,
    y1: 122.076,
    x2: 823.19,
    y2: 128.076,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 823.19,
    y1: 140.462,
    x2: 823.19,
    y2: 431.546,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 823.19,
    y1: 437.739,
    x2: 823.19,
    y2: 443.739,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 694.979,
    y1: 121.187,
    x2: 694.979,
    y2: 442.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 694.979,
    y1: 121.187,
    x2: 694.979,
    y2: 127.187,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 694.979,
    y1: 139.573,
    x2: 694.979,
    y2: 430.657,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 694.979,
    y1: 436.85,
    x2: 694.979,
    y2: 442.85,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 568.436,
    y1: 122.685,
    x2: 568.436,
    y2: 444.348,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 568.436,
    y1: 122.685,
    x2: 568.436,
    y2: 128.685,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.436,
    y1: 141.071,
    x2: 568.436,
    y2: 432.155,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.436,
    y1: 438.348,
    x2: 568.436,
    y2: 444.348,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 440.689,
    y1: 122.31,
    x2: 440.689,
    y2: 443.973,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 440.689,
    y1: 122.31,
    x2: 440.689,
    y2: 128.31,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.689,
    y1: 140.696,
    x2: 440.689,
    y2: 431.78,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.689,
    y1: 437.973,
    x2: 440.689,
    y2: 443.973,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 304.614,
    y1: 122.178,
    x2: 304.614,
    y2: 443.841,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 304.614,
    y1: 122.178,
    x2: 304.614,
    y2: 128.178,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.614,
    y1: 140.564,
    x2: 304.614,
    y2: 431.648,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.614,
    y1: 437.841,
    x2: 304.614,
    y2: 443.841,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 182.078,
    y1: 123.286,
    x2: 182.078,
    y2: 444.95,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 182.078,
    y1: 123.286,
    x2: 182.078,
    y2: 129.286,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.078,
    y1: 141.672,
    x2: 182.078,
    y2: 432.756,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.078,
    y1: 438.95,
    x2: 182.078,
    y2: 444.95,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 65.144,
    y1: 281.987,
    x2: 1306.839,
    y2: 281.987,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 65.144,
    y1: 281.987,
    x2: 71.144,
    y2: 281.987,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.083,
    y1: 281.987,
    x2: 1294.869,
    y2: 281.987,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 11.939 11.939",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300.839,
    y1: 281.987,
    x2: 1306.839,
    y2: 281.987,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1336.401,
    y1: 18.812,
    x2: 1336.401,
    y2: 115.376,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 55.272,
    y1: 20.115,
    x2: 55.272,
    y2: 114.894,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1336.238,
    y1: 57.209,
    x2: 1067.256,
    y2: 57.209,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1307.533,
    y1: 57.209,
    x2: 1067.256,
    y2: 57.209,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1301.697 37.264 1336.238 57.209 1301.697 77.154 1301.697 37.264"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 695.6,
    y1: 57.231,
    x2: 980.147,
    y2: 57.231,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 724.305,
    y1: 57.231,
    x2: 980.147,
    y2: 57.231,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "730.141 77.177 695.6 57.231 730.141 37.286 730.141 77.177"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1336.221,
    y1: 34.568,
    x2: 405.278,
    y2: 34.568,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1307.516,
    y1: 34.568,
    x2: 405.278,
    y2: 34.568,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1301.68 14.622 1336.221 34.568 1301.68 54.513 1301.68 14.622"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 49.679,
    y1: 42.554,
    x2: 306.266,
    y2: 42.554,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 78.384,
    y1: 42.554,
    x2: 306.266,
    y2: 42.554,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.22 62.499 49.679 42.554 84.22 22.608 84.22 62.499"
  })))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 695.787,
    y1: 41.836,
    x2: 695.787,
    y2: 112.667,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1224.385 102.74)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1096.385 102.177)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(978.092 102.553)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(850.817 102.299)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(727.835 101.85)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(604.195 102.285)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(480.793 102.472)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(374.353 102.42) rotate(-180) scale(1 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(234.347 102.32)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(127.514 101.742) rotate(-180) scale(1 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1001.342 64.476)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20ft"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(340.276 49.414)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40ft"))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1338.059,
    y1: 154.163,
    x2: 56.676,
    y2: 156.163,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1339.706,
    y1: 406.263,
    x2: 58.323,
    y2: 408.263,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.283 138.105) rotate(-180) scale(1 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(32.591 226.246) rotate(-180) scale(1 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30,
    letterSpacing: "-.018em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.082 348.009)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.533 436.769)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSideContainer);
export default __webpack_public_path__ + "static/media/Left Side Container.4c70b0ceae794da504234aabcc427c0d.svg";
export { ForwardRef as ReactComponent };